import { createFileRoute } from '@tanstack/react-router';

import { IntakePage } from '../../portal/intake-page';

/**
 * `/account/intake` — complete or resume the health form (M10.5, M8.7, FR-INTAKE-03).
 *
 * `?appointmentId=` names the visit when the caller already knows it: the appointment
 * detail page links straight here, and until M10.1 publishes the appointment list it is
 * the only way to reach a real submission (the overview is still a fixture). An
 * appointment id is an opaque uuid the API scopes to the session's own patient, so the
 * query carries nothing about anybody (rules §25). Anything unparseable is dropped rather
 * than refused — a stale link must open the page, not break it.
 */
export const Route = createFileRoute('/account/intake')({
  validateSearch: (search: Record<string, unknown>): { appointmentId?: string } => {
    const raw = search['appointmentId'];
    return typeof raw === 'string' && raw.trim() !== '' ? { appointmentId: raw } : {};
  },
  component: IntakeRoute,
});

function IntakeRoute() {
  const { appointmentId } = Route.useSearch();
  return <IntakePage {...(appointmentId === undefined ? {} : { appointmentId })} />;
}
